import React from 'react';
import { Button, SplitButton } from '@innovyze/stylovyze';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { MenuGrid } from './EditValuemappingProfile.styles';
import { useGlobalization } from '@Translations/useGlobalization';

interface ControlButtonsProps {
	onClickCancelButton(): void;
	onClickSaveButton(): void;
	onClickDeleteButton(): void;
	disabled: boolean;
}

const ControlsButtons: React.FC<ControlButtonsProps> = (
	props: ControlButtonsProps,
) => {
	const { t } = useGlobalization();
	const {
		onClickCancelButton,
		onClickSaveButton,
		onClickDeleteButton,
		disabled,
	}: ControlButtonsProps = props;

	const splitButtonsOptions = [
		{
			title: t('Save'),
			onClick: onClickSaveButton,
			cy: 'SaveButton',
			key: 0,
			icon: <></>,
		},
	];

	splitButtonsOptions.push({
		title: t('Delete'),
		onClick: onClickDeleteButton,
		cy: 'deleteProfile',
		key: 1,
		icon: <DeleteIcon data-cy="delete" />,
	});

	return (
		<MenuGrid>
			<Button
				variant="contained"
				onClick={onClickCancelButton}
				data-cy="cancel-action-button">
				{t('Cancel')}
			</Button>
			<SplitButton
				options={splitButtonsOptions}
				includeSelectedInMenu={false}
				oneClickMenu
				disabled={disabled}
			/>
		</MenuGrid>
	);
};

export default ControlsButtons;
